import { Box, styled, Modal } from '@/theme/index';

export const StyledModal = styled(Modal)`
  border-radius: '20px';
`;

export const ModalBox = styled(Box)`
  display: 'flex',
  flex-direction: 'column',
  justify-content: 'space-between',
  align-items: 'center',
`;
